module.exports = __webpack_public_path__ + "img/EXTERIOR-SWIFT-1.187f6e6c.jpg";